import API from './base';

class ExamCentersSearchAdsAPI extends API {
  apiBase = '/api/web/v1/exam_centers_search_ads';

  getAdsByCoordinates(latitude, longitude, radius) {
    const today = new Date();
    const queryParams = new URLSearchParams({
      latitude,
      longitude,
      timezone: today.getTimezoneOffset(),
    });

    if (radius) {
      queryParams.append('radius', radius);
    }

    return this.get(this.apiBase, queryParams);
  }

  getAdsByDepartmentAndCity(department, city) {
    const queryParams = new URLSearchParams({
      department,
    });
    if (city) { queryParams.append('city', city); }

    return this.get(this.apiBase, queryParams);
  }
}

export default new ExamCentersSearchAdsAPI();
